export default "__VITE_ASSET__BHTWP7_t__"